import { createContext, useContext } from "react";

import { AreaKey } from "./pageVocabulary.generated";

/**
 * The permission area of the route the current page is mounted under, supplied once by
 * ProtectedRoute. Pages and their children read it from here rather than repeating the area key,
 * so a page and its route can never disagree about which grant governs it.
 */
export const RouteAreaContext = createContext<AreaKey | undefined>(undefined);

export const useRouteArea = () => useContext(RouteAreaContext);
